<template>
  <header class="header">
    <div class="header-left">
      <h1
        class="header-logo"
        :style="{ cursor: showBack ? 'pointer' : 'default' }"
        @click="showBack && goToDashboard()"
      >
        FormMan
        <span class="header-version">v{{ appVersion }}</span>
      </h1>
      <template v-if="showBack">
        <div class="header-divider" />
        <div class="header-info">
          <div class="header-stage">{{ STAGE_NAMES[store.currentStage] }}</div>
          <div v-if="store.currentTemplate?.fileName" class="header-template">
            {{ store.currentTemplate.fileName }}
          </div>
        </div>
      </template>
    </div>

    <div v-if="showBack" class="header-actions">
      <button class="btn btn-secondary" @click="store.saveDraft()">Save Draft</button>
      <button class="btn btn-secondary">Help</button>
    </div>
  </header>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRouter } from 'vue-router'
import { WorkflowStage } from '../../types'
import { useWorkflowStore } from '../../stores/workflow'

declare const __APP_VERSION__: string
const appVersion = __APP_VERSION__

const store = useWorkflowStore()
const router = useRouter()

const showBack = computed(() => store.mode === 'workflow')

async function goToDashboard() {
  await router.push('/')
  store.backToDashboard()
}

const STAGE_NAMES: Record<WorkflowStage, string> = {
  [WorkflowStage.UPLOAD]: 'Upload Template',
  [WorkflowStage.MOBILE]: 'Mobile Wizard',
  [WorkflowStage.STAMPZ]: 'Program Stampz',
  [WorkflowStage.REGISTER]: 'URL Registration',
  [WorkflowStage.STICKERS]: 'eRx Stickers',
  [WorkflowStage.FIELDS]: 'Field Assignment',
  [WorkflowStage.MAPPING]: 'FHIR Mapping',
  [WorkflowStage.REVIEW]: 'Review',
  [WorkflowStage.EXPORT]: 'Export',
}
</script>
